<template>
  <div class="registry-info" data-flyout="registry">
    <slot :data="{ title, 'text-transform': isMcom }"></slot>
    <div v-if="hasRegestries || showSignIn" class="hnf-occasions padding-bottom-s padding-top-s">
      <div class="medium margin-bottom-xs">Manage your registry</div>
      <ul class="grid-y">
        <li v-if="showSignIn" class="link-item">
          <Link class="menu-link-body" :href="defaultLinks.signinUrl" tabindex="0" @click="setSignInRedirectParams"> Sign in </Link>
        </li>
        <li v-for="occasion of occasions" :key="occasion.registryId" class="link-item">
          <Link
            class="menu-link-body"
            :href="'/registry/' + occasion.registryId"
            tabindex="0"
            @click.prevent="setDefaultRegistry(occasion.registryGUID)"
          >
            {{ occasion.text }}
          </Link>
        </li>
      </ul>
    </div>

    <div v-for="(group, index) of linkGroups" :key="index" class="hnf-registry-info padding-top-s">
      <div v-if="group.title" class="medium margin-bottom-xs">
        {{ group.title }}
      </div>
      <ul class="grid-y">
        <li v-for="link of group.items" :key="link.text" class="link-item">
          <Link class="menu-link-body" :href="link.url" tabindex="0">
            {{ link.text }}
          </Link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { useRegistry, useRegistryDropdown } from '~/composables/useRegistry';
import Link from '../common/Link';
import { useEnvProps } from '~/stores/envProps';

const { isMcom } = useEnvProps();
const { hasRegestries, showSignIn, occasions, linkGroups, title } = useRegistryDropdown();
const { defaultLinks, setDefaultRegistry, setSignInRedirectParams } = useRegistry();
</script>

<style lang="scss" scoped>
@import '~/assets/scss/mixins/index.scss';

.registry-info {
  .hnf-occasions {
    border-bottom: $hr-gray-divider;
  }

  .hnf-registry-info + .hnf-registry-info {
    border-top: $hr-gray-divider;
    @include margin-top-s;
  }

  ul {
    gap: 16px;
  }
}
</style>
